import { NgModule } from '@angular/core';
import { NcCommonService } from './common.service';

@NgModule({
    providers: [NcCommonService]
})
export class NcCommonServiceModule { }